"use client";
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false); 
  };

  const isActive = (path) => {
    return location.pathname === path || (path === '/home' && location.pathname === '/');
  };

  const headerVariants = {
    initial: { opacity: 0, y: -100 },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const logoVariants = {
    initial: { opacity: 0, scale: 0.8 },
    animate: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        delay: 0.2,
        ease: "easeOut"
      }
    },
    hover: {
      scale: 1.05,
      transition: { duration: 0.2 }
    }
  };

  const navVariants = {
    initial: { opacity: 0, x: 100 },
    animate: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        delay: 0.4,
        ease: "easeOut"
      }
    }
  };

  const mobileMenuVariants = {
    initial: { opacity: 0, height: 0 },
    animate: {
      opacity: 1,
      height: "auto",
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    },
    exit: {
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.3,
        ease: "easeIn"
      }
    }
  };

  return (
    <motion.header
      className="relative w-full bg-orange-50 h-[118px]"
      variants={headerVariants}
      initial="initial"
      animate="animate"
    >
      <motion.div
        className="flex absolute justify-center items-center px-2.5 py-3.5 h-auto left-[93px] top-[25px] w-[249px] max-xl:left-8 max-lg:left-4 max-md:w-[200px] max-sm:w-[180px]"
        variants={logoVariants}
        initial="initial"
        animate="animate"
        whileHover="hover"
      >
        <div className="flex gap-2.5 items-center h-[39px] w-[229px] max-md:w-[180px] max-sm:w-[160px]">
           <img
            src="https://api.builder.io/api/v1/image/assets/TEMP/365ffa53b9e278e408248b662141c7b81b7ce061?width=410"
            alt="The Cakes & Desserts Logo"
            className="h-[100px] w-auto object-contain max-md:h-[80px] max-sm:h-[160px] cursor-pointer"
            onClick={() => handleNavigation('/home')}
          /> 
          
        </div>
      </motion.div>

      {/* Main Navigation for Desktop */}
      <motion.nav
        className="inline-flex absolute top-9 gap-8 xl:gap-14 items-center h-[px] left-[600px] xl:left-[781px] w-auto max-xl:hidden"
        role="navigation"
        aria-label="Main navigation"
        variants={navVariants}
        initial="initial"
        animate="animate"
      >
        {/* Navigation Links */}
        <motion.div
          className={`flex gap-2.5 justify-center items-center px-4 pt-2 pb-2 rounded-[50px] ${isActive('/home') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'} transition-colors cursor-pointer`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <button
            onClick={() => handleNavigation('/home')}
            className={`text-lg ${isActive('/home') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'} transition-colors`}
          >
            Home
          </button>
        </motion.div>

        <motion.div
          className={`flex gap-2.5 justify-center items-center px-4 pt-2 pb-2 rounded-[50px] ${isActive('/menu') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'} transition-colors cursor-pointer`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <button
            onClick={() => handleNavigation('/menu')}
            className={`text-lg ${isActive('/menu') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'} transition-colors`}
          >
            Menu
          </button>
        </motion.div>

        <motion.div
          className={`flex gap-2.5 justify-center items-center px-4 pt-2 pb-2 rounded-[50px] ${isActive('/about') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'} transition-colors cursor-pointer`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <button
            onClick={() => handleNavigation('/about')}
            className={`text-lg ${isActive('/about') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'} transition-colors`}
          >
            About Us
          </button>
        </motion.div>

        {/* <motion.div
          className={`flex gap-2.5 justify-center items-center px-4 pt-2 pb-2 rounded-[50px] ${isActive('/shop') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'} transition-colors cursor-pointer`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <button
            onClick={() => handleNavigation('/shop')}
            className={`text-lg ${isActive('/shop') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'} transition-colors`}
          >
            Shop
          </button>
        </motion.div> */}

        {/* <motion.div
          className={`flex gap-2.5 justify-center items-center px-4 pt-2 pb-2 rounded-[50px] ${isActive('/contact') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'} transition-colors cursor-pointer`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <button
            onClick={() => handleNavigation('/contact')}
            className={`text-lg ${isActive('/contact') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'} transition-colors`}
          >
            Contact
          </button>
        </motion.div> */}
      </motion.nav>

      {/* Mobile Menu Button */}
      <motion.button
        className="absolute right-5 top-9 xl:hidden z-50"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle mobile menu"
        aria-expanded={isMobileMenuOpen}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        <div className="w-6 h-6 flex flex-col justify-center items-center">
          <span className={`bg-cyan-900 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMobileMenuOpen ? 'rotate-45 translate-y-1' : '-translate-y-0.5'}`}></span>
          <span className={`bg-cyan-900 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm my-0.5 ${isMobileMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
          <span className={`bg-cyan-900 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMobileMenuOpen ? '-rotate-45 -translate-y-1' : 'translate-y-0.5'}`}></span>
        </div>
      </motion.button>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.nav
            className="absolute top-[118px] left-0 w-full bg-orange-50 shadow-lg xl:hidden z-40"
            variants={mobileMenuVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <div className="flex flex-col py-4 px-6 space-y-4">
              {/* Mobile Menu Buttons */}
            <motion.div
  onClick={() => handleNavigation('/home')}
  className={`flex gap-2.5 justify-center items-center px-4 pt-2 pb-2 rounded-[50px] ${
    isActive('/home') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'
  } transition-colors cursor-pointer`}
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
>
  <span
    className={`text-lg ${
      isActive('/home') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'
    } transition-colors`}
  >
    Home
  </span>
</motion.div>

<motion.div
  onClick={() => handleNavigation('/menu')}
  className={`flex gap-2.5 justify-center items-center px-4 pt-2 pb-2 rounded-[50px] ${
    isActive('/menu') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'
  } transition-colors cursor-pointer`}
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
>
  <span
    className={`text-lg ${
      isActive('/menu') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'
    } transition-colors`}
  >
    Menu
  </span>
</motion.div>


           <motion.div
  onClick={() => handleNavigation('/about')}
  className={`flex gap-2.5 justify-center items-center px-4 pt-2 pb-2 rounded-[50px] ${
    isActive('/about') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'
  } transition-colors cursor-pointer`}
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.95 }}
>
  <span
    className={`text-lg ${
      isActive('/about') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'
    } transition-colors`}
  >
    About us
  </span>
</motion.div>


              {/* <motion.div
                className={`flex gap-2.5 justify-start items-center px-4 pt-2 pb-2 rounded-[50px] ${isActive('/shop') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'} transition-colors cursor-pointer`}
                whileHover={{ x: 10 }}
                transition={{ duration: 0.2 }}
              >
                <button
                  onClick={() => handleNavigation('/shop')}
                  className={`text-lg ${isActive('/shop') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'} transition-colors text-left`}
                >
                  Shop
                </button>
              </motion.div> */}

              {/* <motion.div
                className={`flex gap-2.5 justify-start items-center px-4 pt-2 pb-2 rounded-[50px] ${isActive('/contact') ? 'bg-red-500' : 'bg-transparent hover:bg-red-100'} transition-colors cursor-pointer`}
                whileHover={{ x: 10 }}
                transition={{ duration: 0.2 }}
              >
                <button
                  onClick={() => handleNavigation('/contact')}
                  className={`text-lg ${isActive('/contact') ? 'text-orange-50' : 'text-cyan-900 hover:text-red-500'} transition-colors text-left`}
                >
                  Contact
                </button>
              </motion.div> */}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
